import React from "react";
import { Row, Col, Button, Modal, Form, Container } from "react-bootstrap";
import t from "tcomb-form";
import "./AddState.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddState extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        name: "",
        code: "",
        type: "Select Type",
        capital: "",
        latitude: "",
        longitude: ""
      }
    };

    this.onChangehandler = this.onChangehandler.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.submit = this.submit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  onChangehandler = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "name") {
      this.setState({
        value: { ...this.state.value, name: value }
      });
    } else if (name === "code") {
      this.setState({ value: { ...this.state.value, code: value } });
    } else if (name === "capital") {
      this.setState({ value: { ...this.state.value, capital: value } });
    } else if (name === "latitude") {
      this.setState({ value: { ...this.state.value, latitude: value } });
    } else if (name === "longitude") {
      this.setState({ value: { ...this.state.value, longitude: value } });
    }
  };

  onChangeOption = event => {
    this.setState({ value: { ...this.state.value, type: event.target.value } });
  };

  submit() {
    if (
      this.state.value.latitude !== "" &&
      this.state.value.longitude !== "" &&
      this.state.value.type !== "Select Type" &&
      this.state.value.name !== "" &&
      this.state.value.code !== "" &&
      this.state.value.capital !== ""
    ) {
      this.props.addState(this.state.value);
      this.setState({
        value: {
          name: "",
          code: "",
          type: "Select Type",
          capital: "",
          latitude: "",
          longitude: ""
        }
      });
      this.props.handleClose();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  closeModal() {
    this.setState({
      value: {
        name: "",
        code: "",
        type: "Select Type",
        capital: "",
        latitude: "",
        longitude: ""
      }
    });
    this.props.handleClose();
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.ShowAddModel}
          onHide={this.closeModal}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
             style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
             closeButton
          >
          <Modal.Title>State</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
              <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
              <Row>
              <Form.Group
                          controlId="name"
                          style={{ width: "100%" }}
                        >
              <Form.Label className="mandatoryField">Type</Form.Label>
              <div style={{width:"100%"}}>
                          <select style={{width:"100%"}}
                      onChange={this.onChangeOption}
                      class="form-control"
                      className="stateSelect"
                      id="type"
                      value={this.state.value.type}
                    >
                      <option value="select" defaultValue>
                        Select Type
                      </option>
                      <option value="State">State</option>
                      <option value="Union Territory">Union Territory</option>
                    </select>
                    </div>
                      </Form.Group> 
                      </Row>
                     
                     <Row>

                     <Form.Group controlId="code" style={{ width: "100%" }}>
                          <Form.Label className="mandatoryField">Code</Form.Label>
                          <Form.Control
                          type="text"
                          name="code"
                          autoComplete="off"
                          value={this.state.value.code}
                          onChange={this.onChangehandler}
                        />
                        </Form.Group>
                      
                      </Row>

                      <Row>
                      <Form.Group
                          controlId="latitude"
                          style={{ width: "100%" }}
                        >
                          <Form.Label className="mandatoryField">
                            Latitude</Form.Label>
                          <Form.Control
                          type="text"
                          autoComplete="off"
                          name="latitude"
                          value={this.state.value.latitude}
                          onChange={this.onChangehandler}
                        />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                      <Form.Group
                          controlId="name"
                          style={{ width: "100%" }}
                        >
                          <Form.Label className="mandatoryField">Name</Form.Label>
                          <Form.Control
                          type="text"
                          autoComplete="off"
                          name="name"
                          value={this.state.value.name}
                          onChange={this.onChangehandler}
                        />
                        </Form.Group>
                      </Row>
                      <Row>
                      <Form.Group controlId="capital" style={{ width: "100%" }}>
                          <Form.Label className="mandatoryField">Capital</Form.Label>
                          <Form.Control
                          type="text"
                          name="capital"
                          autoComplete="off"
                          value={this.state.value.capital}
                          onChange={this.onChangehandler}
                        />
                        </Form.Group>
                      </Row>
                      <Row>
                      <Form.Group controlId="longitude" style={{ width: "100%" }}>
                          <Form.Label className="mandatoryField">Longitude</Form.Label>
                          <Form.Control
                          type="text"
                          name="longitude"
                          autoComplete="off"
                          value={this.state.value.longitude}
                          onChange={this.onChangehandler}
                        />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
           <Button
              type="submit"
              onClick={this.submit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddState;
